import { config } from "@/shared/lib/config";
import { fetchLookupForInfinite, hydrateLookupItem } from "@/shared/lib/utils";
import { InfiniteCombobox } from "@/shared/ui/InfiniteCombobox";
import { Button, Card, DatePicker } from "@devhop/ui";
import { formatDateForInput } from "@/shared/lib/date-time";

type DepartmentItem = { id: string; name: string };

type QCResultFilterProps = {
  departmentId: string;
  startDate: string;
  endDate: string;
  onDepartmentChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onFilterChange: () => void;
};

export function QCResultFilter({
  departmentId,
  startDate,
  endDate,
  onDepartmentChange,
  onStartDateChange,
  onEndDateChange,
  onFilterChange,
}: QCResultFilterProps) {
  const handleDateRangeChange = (
    range:
      | {
          from?: Date;
          to?: Date;
        }
      | Date[]
      | undefined,
  ) => {
    const from: Date | undefined = Array.isArray(range)
      ? range[0]
      : range?.from;
    const to: Date | undefined = Array.isArray(range) ? range[1] : range?.to;
    const fromStr = from ? formatDateForInput(from) : "";
    const toStr = to ? formatDateForInput(to) : "";
    onStartDateChange(fromStr);
    onEndDateChange(toStr);
  };

  return (
    <Card className="p-4" data-tourid="result-filter">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div>
          <div className="mb-1 font-medium text-sm">ພະແນກ</div>
          <InfiniteCombobox<DepartmentItem>
            queryKey={["qc-departments", "result-filter"]}
            queryFn={(args) =>
              fetchLookupForInfinite(
                `${config.apiUrl}/qc/departments/lookup`,
                args,
              )
            }
            preloadQueryFn={(id) =>
              hydrateLookupItem(`${config.apiUrl}/qc/departments/lookup`, id)
            }
            getLabel={(item) => item.name}
            getValue={(item) => item.id}
            value={departmentId}
            onValueChange={onDepartmentChange}
            placeholder="ທຸກພະແນກ"
            clearable
          />
        </div>
        <div>
          <div className="mb-1 font-medium text-sm">ຊ່ວງວັນທີ</div>
          <DatePicker
            mode="range"
            value={{
              from: startDate ? new Date(startDate) : undefined,
              to: endDate ? new Date(endDate) : undefined,
            }}
            onChange={handleDateRangeChange}
            placeholder="ເລືອກຊ່ວງວັນທີ"
            className="w-full"
          />
        </div>
        <div className="flex items-end">
          <Button onClick={onFilterChange} className="w-full">
            ກວດສອບ
          </Button>
        </div>
      </div>
    </Card>
  );
}
